import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { toLakhs, getBrandOptions } from "../../utils/constants";
function EffortAnalysisReports() {
  const [data, setData] = useState([{}]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const [MonthRange, setMonthRange] = useState([new Date(), new Date()]);


  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/effortanalysis",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          month: MonthRange,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  function get3MonthDateRange(startDate, endDate) {
    if (!startDate || !endDate) return { days: 0 }; // Return 0 if either date is missing
  
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    // Set startDate to the first day of the start month
    const startOfMonth = new Date(start.getFullYear(), start.getMonth(), 1);
  
    // Set endDate to the last day of the end month
    const endOfMonth = new Date(end.getFullYear(), end.getMonth() + 1, 0, 23, 59, 59);
  
    // Total number of days between startOfMonth and endOfMonth
    const msInDay = 1000 * 60 * 60 * 24;
    const totalDays = Math.floor((endOfMonth - startOfMonth) / msInDay) + 1;
  
    return {
      startTimestamp: Math.floor(startOfMonth.getTime() / 1000),
      endTimestamp:Math.min(Math.floor((Date.now() /1000)),  Math.floor(endOfMonth.getTime() / 1000)),
      days: totalDays
    };
  }
  
  
  const { startTimestamp, endTimestamp } = get3MonthDateRange(MonthRange[0], MonthRange[1]);
const dayTimestamps = [];
for (let ts = startTimestamp; ts <= endTimestamp; ts += 86400) {
  dayTimestamps.push(ts);
}

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const tableArray = [];
      tableArray.push(["Mapped Accounts",data.stats?.brand_count || "-", data.stats?.sales_count || "-", "-", "-", "-", "-", "-", "-", "-", "-"]);

      // Add Header Row
      tableArray.push([
        "Date",
        "No. of Clients Meetings",
        "Avg meetings / person",
        "Clients Covered this Month",
        "% of Coverage",
        "Mapped active on Eenadu",
        "Eenadu active on w2n",
        "Missings",
        "Known",
        "Unknown",
        "Unknown%"
      ]);

    
      // Add Data Rows
      dayTimestamps.map(formattedDate => {
        const dateObj = new Date(formattedDate * 1000);
        const year = dateObj.getFullYear();
        const month = dateObj.getMonth() + 1;
        const day = dateObj.getDate();
        const rowData = data?.data?.find(d => d.date === formattedDate) || {};
    
        const totalKnownUnknown = (+rowData.known || 0) + (+rowData.unknown || 0);
        const unknown_percentage = totalKnownUnknown ? ((+rowData.unknown / totalKnownUnknown) * 100).toFixed(2) : "0";
    
        tableArray.push([
          `${day}-${month}-${year}`,
          rowData.interactions || "-",
          ((+rowData.interactions || 0) / data.stats?.sales_count).toFixed(1) || "-",
          +rowData.clients_covered || 0,
          ((+rowData.clients_covered / data?.stats?.brand_count) || 0).toFixed(2),
          +rowData.clients || "-",
          +rowData.active_clients || "-",
          +rowData.missed || "-",
          +rowData.known || "-",
          +rowData.unknown || "-",
          unknown_percentage
        ]);
      });
    
      // Add Total Row
      tableArray.push([
        "Total",
        "",
        "",
        "",
        "",
        "",
        "",
        data?.data?.reduce((sum, d) => sum + (+d.missed || 0), 0),
        data?.data?.reduce((sum, d) => sum + (+d.known || 0), 0),
        data?.data?.reduce((sum, d) => sum + (+d.unknown || 0), 0),
        (
          ((data?.data?.reduce((sum, d) => sum + (+d.unknown || 0), 0) /
            (data?.data?.reduce((sum, d) => sum + (+d.known || 0), 0) +
              data?.data?.reduce((sum, d) => sum + (+d.unknown || 0), 0))) || 0) * 100
        ).toFixed(2)
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet(tableArray);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Effort Analysis");
      XLSX.writeFile(workbook, `EffortAnalysis.xlsx`);
    } catch (error) {
      console.error(error, "Effort Analysis");
    } finally {
      setDownloadLoader(false);
    }
  };
  useEffect(() => {
    fetchNewspapers();
  }, []);

  const handleMonthChange = (date) => {
    setMonthRange(date);
  };

  useEffect(()=>{
    fetchData()
  },[MonthRange, selectedNewspaper, selectedType])
  const getClientsCoveredtillDate = (timestamp) => {
    let rowData = data?.data || [];
  
    // Sort in ascending order of date
    rowData.sort((a, b) => a.date - b.date);
  
    let res = 0; // Store the last valid value
  
    for (const row of rowData) {
      if (row.date > timestamp) break; // Stop early if we pass the timestamp
      if (row.clients_covered > 0) res = row.clients_covered;
    }
  
    return res; // Return the latest valid value before or on timestamp
  };
  
  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Effort Analysis</h5>
        <aside className="flex gap-3 items-center">
          <SlSelect
            size="small"
            value={selectedType}
            label="Team"
            onSlChange={(e) => {
              setSelectedType(e.target.value);
            }}
          >
            {data?.userType === -1 ? (
              <SlOption value="all">All</SlOption>
            ) : null}
            {getBrandOptions(
              data?.userType,
              localStorage.getItem("email")
            )?.map((type) => (
              <SlOption key={type.value} value={type.value}>
                {type.label}
              </SlOption>
            ))}
          </SlSelect>
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          <div className="clientwiserevenue-datepicker max-w-[200px] ">
            <label className="form-label">Select Month</label>
            <DatePicker
              selected={MonthRange[0]}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              startDate={MonthRange[0]}
              endDate={MonthRange[1]}
              className="dateChooser border h-5 rounded-md"
              selectsRange
              maxDate={new Date()}
            />
          </div>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
      <table className="table table-bordered tbodyscroll " >
  <thead className="bg-yellow-300">
    <tr>
      <th colSpan={1}>Mapped Accounts</th>
      <td>{data?.stats?.brand_count}</td>
      <td className="font-semibold">Sales Persons: {data?.stats?.sales_count}</td> {/* Fixed typo from sales_cpiunt */}
    </tr>
    <tr>
      <th>Date</th>
      <th>No. of Clients Meetings</th>
      <th>Avg meetings / person</th>
      <th>Clients Covered this Month</th>
      <th>% of Coverage</th>
      <th>Mapped active on Eenadu</th>
      <th>Eenadu active on w2n</th>
      <th>Missings</th>
      <th>Known</th>
      <th>Unknown</th>
      <th>Unknown%</th>
    </tr>
  </thead>
  
  {!loader && data?.data?.length > 0 ? (
  <tbody>
   {dayTimestamps.map((formattedDate, index1) => {
    const dateObj = new Date(formattedDate * 1000);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    const rowData = data?.data?.find(d => d.date === formattedDate) || {};
    const totalKnownUnknown = (+rowData.known || 0) + (+rowData.unknown || 0);
    const unknown_percentage = totalKnownUnknown
      ? ((+rowData.unknown / totalKnownUnknown) * 100).toFixed(2)
      : "0";

    return (
      <tr key={formattedDate}>
        <td className="!bg-orange-100">{`${day}-${month}-${year}`}</td>
        <td>{rowData.interactions || "-"}</td>
        <td>{((+rowData.interactions || 0) / data.stats?.sales_count).toFixed(1) || "-"}</td>
        <td>{getClientsCoveredtillDate(formattedDate)}</td>
        <td>{((getClientsCoveredtillDate(formattedDate) / data?.stats?.brand_count) * 100 || 0).toFixed(2)}</td>
        <td>{+rowData.clients || "-"}</td>
        <td>{+rowData.active_clients || "-"}</td>
        <td>{+rowData.missed || "-"}</td>
        <td>{+rowData.known || "-"}</td>
        <td>{+rowData.unknown || "-"}</td>
        <td>{unknown_percentage}</td>
      </tr>
    );
  })}

    {/* Total Row */}
    <tr className="bg-gray-200 font-bold">
  <td>Total</td>
  <td>{data?.data?.reduce((sum, d) => sum + (+d.interactions || 0), 0)}</td>
  <td>{(
    ((data?.data?.reduce((sum, d) => sum + (+d.interactions || 0), 0)) /
    (data.stats?.sales_count || 1)) /
    dayTimestamps.length
  ).toFixed(2)}</td>
  <td></td>
  <td></td>
  <td>{data?.data?.reduce((sum, d) => sum + (+d.clients || 0), 0)}</td> 
  <td>{data?.data?.reduce((sum, d) => sum + (+d.active_clients || 0), 0)}</td>
  <td>{data?.data?.reduce((sum, d) => sum + (+d.missed || 0), 0)}</td>
  <td>{data?.data?.reduce((sum, d) => sum + (+d.known || 0), 0)}</td>
  <td>{data?.data?.reduce((sum, d) => sum + (+d.unknown || 0), 0)}</td>
  <td>
    {(
      ((data?.data?.reduce((sum, d) => sum + (+d.unknown || 0), 0) /
        (data?.data?.reduce((sum, d) => sum + (+d.known || 0), 0) +
         data?.data?.reduce((sum, d) => sum + (+d.unknown || 0), 0))) || 0) * 100
    ).toFixed(2)}
  </td>
</tr>

  </tbody>
) : loader ? (
  <TableSkelton rowSpan={15} colspan={11} />
) : (
  <NoDataFound colspan={11} />
)}

</table>

      </ScrollContainer>
    </>
  );
}

export default EffortAnalysisReports;
